define('views/user/accountholderagreement/accountholderagreement',[
    'backbone',
    'text!views/user/accountholderagreement/accountholderagreement.html',
    'views/_base/baseview'
], function (Backbone, Template, BaseView) {
    'use strict';

    return BaseView.extend({
        id        : 'userAccountholderAgreement',
        tagName   : 'section',
        className : 'legalDoc',
        template  : _.template(Template),
        isRender  : true,
        needsAuth : false,
        events    : {},
        initialize: function(options){
            options = options || {};

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },
        render: function(){
            
            this.$el.html(this.template());

            // setTimeout(function(){
            //     that.$el.parent().prepend('<div class="header-spacer header-spacer--logged-out header-spacer--dark"></div>');
            // },50);

            return this;
        },
        close: function(){}
    });
});

